// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import { Box, Heading, Text } from 'theme-ui'
import Url from '../../util/url'
import strings from '../../strings/strings'
import { useUser } from '../../util/auth'

const Integrate = () => {
  const userContext = useUser()
  const userSiteId =
    userContext?.user === null ? '__loading, try refreshing__' : userContext?.user?.site_ids?.[0]

  const snippet = `
    <div
      class="polis"
      data-page_id="PAGE_ID"
      data-site_id="${userSiteId}">
    </div>
    <script async src="${Url.urlPrefix}embed.js"></script>
  `

  return (
    <Box>
      <Box>
        <Heading
          as="h3"
          sx={{
            fontSize: [3, null, 4],
            lineHeight: 'body',
            mb: [3, null, 4]
          }}>
          {strings('pg_integrate')}
        </Heading>
        <Text>{strings('pg_integrate_intro')}</Text>
        <ul>
          <li>{strings('pg_integrate_li_create')}</li>
          <li>{strings('pg_integrate_li_track')}</li>
          <li>{strings('pg_integrate_li_replace')}</li>
        </ul>
        <Box>
          <pre>{snippet}</pre>
        </Box>
      </Box>
    </Box>
  )
}

export default Integrate
